/* OPS-30 Lash Refills: shelf pins (7 August 2026, Marcha's request)

   One chosen set can lead its Type chip. While the Magic chip is on, the
   pinned Magic set sits first; clear the chip and it drops straight back
   to its Best Selling position. Nothing else on the shelf moves, so the
   collection keeps sorting itself and no manual order has to be kept up
   to date by hand.

   Config comes from the #lr-pins JSON block rendered by
   sections/lash-refills-bundles.liquid (Restock Ritual hero), which
   paints before the shelf. Set the pins in the theme editor on that
   section, under "Shelf pins".

   This file only ever REORDERS cards. Filtering, eligibility, the moon
   maths and the discount engine are all owned by assets/lash-refills.js
   and are untouched here. The chips belong to that file too, so we read
   aria-pressed on the tick after a click, once it has updated. */

(function () {
  'use strict';
  if (window.__lrPinsInit) return;
  window.__lrPinsInit = true;

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  onReady(function () {
    var grid = document.getElementById('lr-grid');
    var cfgEl = document.getElementById('lr-pins');
    if (!grid || !cfgEl) return;

    var pins = [];
    try { pins = JSON.parse(cfgEl.textContent) || []; } catch (e) { return; }
    pins = pins.filter(function (p) { return p && p.type && p.handle; });
    if (!pins.length) return;

    /* The shelf order as Liquid rendered it, captured before anything moves.
       Every restore rebuilds from this, so repeated chip toggles can never
       drift the order. */
    var order = Array.prototype.slice.call(grid.children);
    var byHandle = {};
    order.forEach(function (el) {
      var h = el.getAttribute('data-handle');
      if (h) byHandle[h] = el;
    });

    /* A pinned product that is not in this collection is simply ignored,
       and logged so it is obvious why nothing moved. */
    pins = pins.filter(function (p) {
      if (byHandle[p.handle]) return true;
      if (window.console && console.info) {
        console.info('lash-refills pins: "' + p.handle + '" is not in this collection, pin skipped.');
      }
      return false;
    });
    if (!pins.length) return;

    var applied = null;

    function activeType() {
      var on = document.querySelector('.lrc-chip[data-filter-group="type"][aria-pressed="true"]');
      return on ? on.getAttribute('data-filter-value') : '';
    }

    function apply() {
      var type = activeType();
      if (type === applied) return;
      applied = type;

      var lead = [];
      pins.forEach(function (p) {
        if (p.type === type && lead.indexOf(byHandle[p.handle]) === -1) lead.push(byHandle[p.handle]);
      });

      var frag = document.createDocumentFragment();
      lead.forEach(function (el) { frag.appendChild(el); });
      order.forEach(function (el) {
        if (lead.indexOf(el) === -1) frag.appendChild(el);
      });
      grid.appendChild(frag);
    }

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      if (e.target.closest('.lrc-chip[data-filter-group="type"]') || e.target.closest('#lr-clear-filters')) {
        setTimeout(apply, 0);
      }
    });
    window.addEventListener('hashchange', function () { setTimeout(apply, 0); });

    apply();
  });
})();
